import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import { getPersistConfig } from "redux-deep-persist";
import storage from "redux-persist/lib/storage";

//reducers
import windowReducer from "./windowReducer";
import revenuePopupReducer from "./revenuePopupReducer";
import sideWindowReducer from "./sideWindowReducer";
import cateringReducer from "./cateringReducer";

const isLoggedReducer = (state = null, action) => {
	switch (action.type) {
		case "TOGGLE":
			return !state;
		case "LOGIN":
			return true;
		case "LOGOUT":
			return false;
		case "LOGIN_SET":
			return action.state;
		default:
			return state;
	}
};

const languageReducer = (state = "PL", action) => {
	switch (action.type) {
		case "PL":
			return "PL";
		case "EN":
			return "EN";
		case "LANGUAGE_SET":
			return action.state;
		case "LANGUAGE_UNSET":
			return null;
		default:
			return state;
	}
};

const groupInfoReducer = (state = null, action) => {
	switch (action.type) {
		case "SET_MONEY":
			return { ...state, money: action.state };
		case "SET_POINTS":
			return { ...state, points: action.state };
		case "SET_FUEL_SUPPLIER":
			return { ...state, fuelSupplier: action.state };
		case "GROUP_INFO_SET":
			return action.state;
		default:
			return state;
	}
};

const configurationsReducer = (state = [], action) => {
	switch (action.type) {
		case "SET_CONFIGURATIONS":
			return action.payload;
		case "ADD_CONFIGURATION":
			return [...state, action.payload];
		case "DELETE_CONFIGURATION":
			return state.filter(c => c.id !== action.payload);
		default:
			return state;
	}
};

const slotsReducer = (state = [], action) => {
	switch (action.type) {
		case "SET_SLOTS":
			return action.slots;
		case "ADD_SLOTS":
			return [...state, ...action.slots];
		case "UPDATE_SLOT":
			return state.map(s => (s.id === action.newSlot.id ? action.newSlot : s));
		case "DELETE_SLOT":
			return state.filter(s => s.id !== action.slotId);
		default:
			return state;
	}
};

const airlineInfoReducer = (state = null, action) => {
	switch (action.type) {
		case "SET_PASSENGERS_TRAVELLED":
			state.info.stats.passangersTraveled = action.payload;
			return { ...state };
		case "SET_AIRLINE_SETTINGS":
			return { ...state, settings: action.state };
		case "AIRLINE_INFO_SET":
			return action.state;
		case "CHANGE_BASE_STAFF_SALARY":
			return {
				...state,
				staffSalary: {
					...state.staffSalary,
					[action.payload.workerType]: state.staffSalary[action.payload.workerType].map((v, i) =>
						i === action.payload.index ? action.payload.value : v
					)
				}
			};
		default:
			return state;
	}
};

const flightPlansReducer = (state = [], action) => {
	switch (action.type) {
		case "SET_FLIGHT_PLANS":
			return action.flightPlans;
		case "ADD_FLIGHT_PLAN":
			if (state.map(p => p.id).includes(action.flightPlan.id)) {
				console.error("Unexpected error: Tried to add a FlightPlan that was already saved!");
				return state;
			}

			return [...state, action.flightPlan];
		case "UPDATE_FLIGHT_PLAN":
			if (!state.map(p => p.id).includes(action.flightPlan.id)) {
				console.error("Unexpected error: Tried to update FlightPlan that wasn't saved!");
				return state;
			}

			return state.map(plan => (plan.id === action.flightPlan.id ? action.flightPlan : plan));
		case "DELETE_FLIGHT_PLAN":
			return state.filter(p => p.id !== action.flightPlanId);
		default:
			return state;
	}
};

const flightsReducer = (state = [], action) => {
	switch (action.type) {
		case "SET_FLIGHTS":
			return action.flights;
		case "ADD_FLIGHTS":
			if (state.some(f => action.flights.map(fl => fl.id).includes(f.id))) {
				console.error("Unexpected error: Tried to add a Flight that was already saved!");
				return state;
			}

			return [...state, ...action.flights];
		case "UPDATE_FLIGHT":
			if (!state.map(p => p.id).includes(action.flight.id)) {
				console.error("Unexpected error: Tried to update a Flight that wasn't saved!");
				return state;
			}

			return state.map(plan => (plan.id === action.flight.id ? action.flight : plan));
		case "DELETE_FLIGHT":
			return state.filter(p => p.id !== action.flightId);
		case "DELETE_FLIGHTS":
			return state.filter(p => !action.flightIds.includes(p.id));
		default:
			return state;
	}
};

const mapReducer = (state = { type: null }, action) => {
	switch (action.type) {
		case "MAP_TYPE_SET":
			return Object.assign(Object.create(state), { type: action.state });
		case "MAP_INFO_SET":
			return action.state;
		default:
			return state;
	}
};

const routesReducer = (state = [], action) => {
	switch (action.type) {
		case "ROUTES_ADD":
			return [...state, action.state];
		case "ROUTE_REMOVE":
			return [...state.filter(r => r.id !== action.id)];
		case "ROUTE_UPDATE":
			return state.map(item => (item.id === action.id ? action.state : item));
		case "ROUTES_SET":
			return action.state;
		default:
			return state;
	}
};

const fleetReducer = (state = null, action) => {
	switch (action.type) {
		case "SET_FLEET":
			if (action.payload instanceof Map) {
				return action.payload;
			}

			if (Array.isArray(action.payload)) {
				return new Map(action.payload.map(obj => [obj.ident, obj]));
			}

			throw new TypeError(`Payload for action 'SET_FLEET' must be an array or a Map but got ${typeof action.payload}`);
		case "AIRCRAFT_UPDATE":
			const newState = new Map(state);
			newState.forEach((_, key) => {
				if (key === action.payload.ident) newState.set(key, action.payload);
			});

			return newState;
		default:
			return state;
	}
};

const aircraftListReducer = (state = null, action) => {
	switch (action.type) {
		case "SET_AIRCRAFT_LIST":
			return action.state;
		default:
			return state;
	}
};

const airportsReducer = (state = null, action) => {
	switch (action.type) {
		case "SET_AIRPORTS":
			return action.state;
		default:
			return state;
	}
};

const boxReducerDefaultState = { tab: null };
const boxReducer = (state = boxReducerDefaultState, action) => {
	switch (action.type) {
		case "CHANGE_BOX_TAB":
			return { ...state, tab: action.tab };
		default:
			return state;
	}
};

const FuelPricesReducer = (state = [], action) => {
	switch (action.type) {
		case "FUEL_PRICES_SET":
			return action.state;
		default:
			return state;
	}
};

function staffRecruitment(state = null, action) {
	switch (action.type) {
		case "SET_STAFF_RECRUITMENT":
			return action.payload;
		case "ADD_STAFF_RECRUITMENT":
			if (state == null) return [action.payload];
			return [...state, action.payload];
		case "DELETE_STAFF_RECRUITMENTS":
			// eslint-disable-next-line no-undef
			return structuredClone(state.filter(r => r.id !== action.payload));
		default:
			return state;
	}
}

function staffReducer(state = null, action) {
	switch (action.type) {
		case "SET_STAFF":
			return action.payload;
		case "ADD_STAFF":
			if (!Array.isArray(action.payload)) {
				throw new TypeError(`Payload for action 'ADD_STAFF' must be an array but got ${typeof action.payload}`);
			}

			if (state == null) return action.payload;
			return [...state, ...action.payload];
		case "DELETE_WORKER":
			return state.filter(w => w.id !== action.payload);
		case "UPDATE_STAFF":
			return [...state];
		default:
			return state;
	}
}

function demandReducer(state = [], action) {
	switch (action.type) {
		case "SET_DEMAND":
			return action.payload;
		case "CREATE_DEMANDS":
			return [...state, ...action.payload];
		case "SUBTRACT_DEMAND":
			const { amount, from, to } = action.payload;

			const subtract = d => {
				d.demand_economy -= amount[0];
				d.demand_premium -= amount[1];
				d.demand_business -= amount[2];
				d.demand_first -= amount[3];
				return { ...d };
			};

			return state.map(d =>
				(d.origin === from && d.destination === to) || (d.origin === from && d.destination === to) ? subtract(d) : d
			);
		default:
			return state;
	}
}

//main reducers
const combinedReducers = combineReducers({
	isLoggedIn: isLoggedReducer,
	lang: languageReducer,
	groupInfo: groupInfoReducer,
	airlineInfo: airlineInfoReducer,
	map: mapReducer,
	window: windowReducer,
	aircraftList: aircraftListReducer,
	airports: airportsReducer,
	routes: routesReducer,
	fleet: fleetReducer,
	fuelPrices: FuelPricesReducer,
	// aircraftPopUp: aircraftPopUpReducer,
	box: boxReducer,
	revenuePopup: revenuePopupReducer,
	catering: cateringReducer,
	slots: slotsReducer,
	flightPlans: flightPlansReducer,
	flights: flightsReducer,
	recruitments: staffRecruitment,
	staff: staffReducer,
	configurations: configurationsReducer,
	demand: demandReducer,
	sideWindow: sideWindowReducer
});

const allReducers = persistReducer(
	getPersistConfig({
		key: "root",
		whitelist: ["lang", "airlineInfo.info", "airlineInfo.hubs", "map", "airports", "window.additionalInformation"],
		storage,
		rootReducer: combinedReducers
	}),
	combinedReducers
);

const rootReducer = (state, action) => {
	if (action.type === "LOGOUT") {
		return allReducers(undefined, action);
	}

	return allReducers(state, action);
};

export default rootReducer;
